export default __webpack_public_path__ + "static/media/Sanyam Jain CV.3c17e9ff.pdf";